// Android 전용 공통 레이어 다이얼로그
// MUI Dialog 기반, Material Design 3 스타일

import React from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Button, Slide } from "@mui/material"
import { TransitionProps } from "@mui/material/transitions"
import CloseRoundedIcon from "@mui/icons-material/CloseRounded"

const SlideUp = React.forwardRef(function SlideUp(props: TransitionProps & { children: React.ReactElement }, ref: React.Ref<unknown>) {
  return <Slide direction="up" ref={ref} {...props} />
})

interface AndroidLayerDialogProps {
  open: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  /** 취소 버튼 텍스트 */
  cancelLabel?: string
  /** 취소 버튼 클릭 핸들러 (미지정 시 onClose) */
  onCancel?: () => void
  /** 확인 버튼 텍스트 (미지정 시 "확인") */
  confirmLabel?: string
  /** 확인 버튼 클릭 핸들러 (미지정 시 onClose) */
  onConfirm?: () => void
  /** 확인 버튼 숨김 */
  hideConfirm?: boolean
  /** 최대 너비 */
  maxWidth?: "xs" | "sm" | "md"
}

/** Android 전용 공통 레이어 (하단에서 슬라이드업, Material Design 3 스타일) */
const AndroidLayerDialog: React.FC<AndroidLayerDialogProps> = ({
  open,
  onClose,
  title,
  children,
  cancelLabel,
  onCancel,
  confirmLabel = "확인",
  onConfirm,
  hideConfirm = false,
  maxWidth = "xs",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      TransitionComponent={SlideUp}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 5,
            overflow: "hidden",
            minWidth: 520,
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 3,
          px: 4,
        }}
      >
        <Typography fontSize={28} fontWeight={700}>
          {title}
        </Typography>
        <IconButton size="large" onClick={onClose} edge="end" aria-label="닫기">
          <CloseRoundedIcon sx={{ fontSize: 36 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 4, pb: hideConfirm ? 5 : 3, "& .MuiTypography-root": { fontSize: 24 } }}>{children}</DialogContent>

      {!hideConfirm && (
        <DialogActions sx={{ px: 4, pb: 4 }}>
          {cancelLabel ? (
            <Button
              variant="outlined"
              onClick={onCancel || onClose}
              sx={{ borderRadius: 3, py: 2, textTransform: "none", minWidth: 140, fontSize: 22 }}
            >
              {cancelLabel}
            </Button>
          ) : null}
          <Button fullWidth variant="contained" onClick={onConfirm || onClose} sx={{ borderRadius: 3, py: 2, textTransform: "none", fontSize: 22 }}>
            {confirmLabel}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}

export default AndroidLayerDialog

